// extracted by mini-css-extract-plugin
export var label = "_8m-1";
export var reminder = "_8m-0";